
<router-outlet></router-outlet>
<ngx-spinner type="ball-atom">
  <p *ngIf="spinner.text()" class="text-white text-2xl font-bold">{{spinner.text()}}</p>
</ngx-spinner>  
